export default "__VITE_ASSET__CtOdkAMw__"